import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { Card } from '@savgroup-front-common/core/atoms/Cards';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Card = styled(Card)<{ isCliquable?: boolean }>`
  @media ${media.maxWidth.sm} {
    padding: ${spacing('lg')};
  }

  transition: 0.15s transform ease-in-out;
  backface-visibility: hidden;
  -webkit-font-smoothing: antialiased;

  ${({ isCliquable }) =>
    isCliquable
      ? `
    &:hover {
      transform: scale3d(1.015, 1.015, 1);
    }
  `
      : ''}
`;

export const $CardContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: row;
  padding: 0 calc(${spacing(3.5)} - 2px);
  @media ${media.maxWidth.sm} {
    flex-direction: column;
    padding: unset;
  }
`;

export const $CardFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: calc(-1 * ${spacing(3.5)}) 0;
`;

export const $Divider = styled.div`
  width: calc(100% + ${spacing(7)});
  height: ${spacing('px')};
  background: ${({ theme }) => theme.colors.default};
  margin: ${spacing('xs')} -1rem ${spacing(5)};
`;
